import { GET_USER_PREFERENCE } from "./commmon-services/get-userpreference";
import { UPDATE_PREFERENCE } from "./commmon-services/update-preference";
import { callOperation } from "async-ops";


export const toTitleCase = (inputString) => {
    if (inputString) {
        const wordsArray = inputString.split(" ");
        const resultArray = [];
        for (const word of wordsArray) {
            resultArray.push(word[0].toUpperCase() + word.slice(1).toLowerCase());
        }
        return resultArray.join(" ");
    } 
    return "";
}

export const isValidEmail = (email) => {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}

export const setUserPreference = (name, settings, reportType = '') => {
    callOperation(UPDATE_PREFERENCE, {
        name: name,
        settings: settings,
        reportType: reportType
    });
};
export const getUserPreference = (name, reportType = ''): Promise<any> => {
    return callOperation(GET_USER_PREFERENCE, {
        name: name,
        reportType: reportType
    })
};